import React from 'react';
import ControlButton from "../../Common/ControlButton";
import uiStore from "../../lib/stores/uiStore";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import Palette from "@mui/icons-material/Palette";
import Group from "@mui/icons-material/Group";
import SpeakerNotes from "@mui/icons-material/SpeakerNotes";
import Box from "../../Common/Box";
import {alpha, useTheme} from "@mui/material/styles";

const Navbar = () => {
    const theme = useTheme();
    const borderColor = alpha(theme.palette.background.paper, 0.4);

    return <Box
            style={{
                width: "100%",
                zIndex: 1,
            }}
            row
            alignItems={"center"}
            justifyContent={"flex-end"}
            padding={"10px"}
            borderBottom={"1px solid " + borderColor}
    >
        <ControlButton
                sx={{marginLeft: "20px"}}
                width={35}
                enabled={uiStore.settingsVisible}
                icon={ManageAccountsIcon}
                label={"Account"}
                onClick={() => {
                    uiStore.settingsVisible = !uiStore.settingsVisible;
                }}
        />
        <ControlButton
                sx={{marginLeft: "20px"}}
                width={35}
                enabled={uiStore.themeManagerVisible}
                icon={Palette}
                onClick={() => {
                    uiStore.themeManagerVisible = !uiStore.themeManagerVisible;
                }}
        />

        <ControlButton
                sx={{marginLeft: "20px"}}
                width={35}
                enabled={uiStore.userListVisible}
                icon={Group}
                onClick={() => {
                    uiStore.userListVisible = !uiStore.userListVisible;
                }}
        />
        <ControlButton
                sx={{marginLeft: "20px"}}
                width={35}
                enabled={uiStore.roomListVisible}
                icon={SpeakerNotes}
                onClick={() => {
                    uiStore.roomListVisible = !uiStore.roomListVisible;
                }}
        />
    </Box>
};

export default Navbar;
